import { useMutation, useQueryClient } from 'react-query';
import { authFetch } from '../../CommonUtils/authFetch';
import { urlWithParams } from '../../CommonUtils/urlWithParams';
import { queryKeys } from './queryKeys';
import { useClientId } from '../../_hooks/useClientId';

interface Params {
  type: 'invite' | 'request';
  clientId: number;
  inviteId: string;
}

const removeItem = async ({ type, clientId, inviteId }: Params): Promise<null> => {
  return authFetch(
    urlWithParams(
      type === 'invite' ? '/BeFi20/survey/RemoveInvite' : '/BeFi20/survey/RejectRequest',
      { clientId, alignment: inviteId },
    ),
    {
      method: 'POST',
    },
  );
};

export const useRemoveItemMutation = () => {
  const queryClient = useQueryClient();
  const clientId = useClientId();

  return useMutation(removeItem, {
    async onSuccess() {
      await queryClient.invalidateQueries(queryKeys.overview(clientId));
    },
  });
};
